/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as backend from './backend';

import { DraftOrder } from '@/models';

export interface DraftOrderItemInput {
  id?: string;
  variantId: string;
  quantity: any;
}

export interface DraftFulfillmentInput {
  serviceId: string;
  addressId?: string;
  itemIds: string[];
}

export interface DraftOrderInput {
  currency: string;
  items: DraftOrderItemInput[];
  fulfillments: DraftFulfillmentInput[];
}

export async function fetchDraftOrder(orderId: string) {
  // TODO: Server-side request
  return backend.fetchDraftOrder(orderId);
}

export async function createDraftOrder(input: Partial<DraftOrderInput>) {
  // TODO: Server-side request
  return backend.createDraftOrder(Object.assign({
    currency: 'TWD',
    items: [],
    fulfillments: [],
  }, input));
}

export async function setDraftOrderItemQuantity(order: DraftOrder, itemId: string, quantity: any) {
  // TODO: Server-side request
  return backend.updateDraftOrder(order.id, {
    items: order.items.map((item) => ({
      id: item.id,
      variantId: item.variant.id,
      quantity: (item.id === itemId) ? quantity : item.quantity,
    })),
  });
}

export async function setDraftOrderFulfillments(order: DraftOrder, fulfillments: DraftFulfillmentInput[]) {
  return backend.updateDraftOrder(order.id, {
    fulfillments,
  });
}
